import Popup from "./Popup";

export default function PopupDifferentCouponTypeClipError({
  isOpen,
  onPrimaryClick,
  onClose,
}: {
  isOpen: boolean;
  onPrimaryClick: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      heading={
        <div>
          以下のクーポンは
          <br />
          同時に利用できません
        </div>
      }
      subheading={
        <div>
          「<span className="font-semibold">お得デークーポン</span>」と「
          <span className="font-semibold">
            ウエルシアメンバー限定10％OFF クーポン
          </span>
          」は併用できせん。どちらか一方のみご選択ください。
        </div>
      }
      primaryButtonLabel="戻る"
      onPrimaryClick={onPrimaryClick}
      testId="popup-different-coupon-type-clip-error"
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
